import { DestinationData } from '../GroupSearchForm/Destination/Destination.types';
import { RoomsAndEventSpace } from '../../molecules/RoomsAndEventSpace/RoomsAndEventSpace.types';
import { CalendarOptions } from '../../molecules/Calendar/Calendar.types';
import { TrackingProperties } from '../NavigationMenu/NavigationMenu.types';

export type HandleSubmit = (data: SearchFormData) => void;

export type ValueType = string | boolean | { label: string; code: string };

export type SearchFormData = {
  destination: { description: string; placeId?: string };
  dates: string;
  startDate: string;
  endDate: string;
  guestRooms: string;
  attendees: string;
  roomsAndEventSpace: RoomsAndEventSpace;
};

export type SearchFormProps = {
  tab: Tab;
  destination: Destination;
  dates: Dates & CalendarOptions;
  guestRooms: GuestRooms;
  attendees: Attendees;
  guestRoomsAndEventSpace: GuestRoomsAndEventSpace;
  ctas: Ctas;
  searchResultsFormData: SearchFormData;
  styleclass: string;
  destinationOnChange: (destination: DestinationData) => void;
  onSubmit: HandleSubmit;
  isSticky: boolean;
  isSearchResultPage: boolean;
  mobileHeading: string;
  trackingProperties: TrackingProperties;
};

type Tab = {
  rooms: string;
  eventSpace: string;
  roomsAndEventSpace: string;
};

type Destination = {
  label: string;
  placeholder: string;
  ariaLabel: string;
  recentSearches: string;
  clearRecents: string;
  clearRecentsAriaLabel: string;
  currentLocation: string;
  requiredError: string;
  mobileHeading: string;
  mobilePlaceholder: string;
};

export type Dates = {
  label: string;
  placeholder: string;
  datePlaceholder: string;
  ariaLabel: string;
  night: string;
  nights: string;
  days: string;
  sameDay: string;
  multipleDays: string;
  singleDay: string;
  message: string;
  requiredError: string;
  mobileHeading: string;
  currentDateError?: string;
};

export type GuestRooms = {
  label: string;
  ariaLabel: string;
  placeholder: string;
  requiredError: string;
  minCountError: string;
  room: string;
  rooms: string;
  mobileRequiredError: string;
};

export type Attendees = {
  label: string;
  ariaLabel: string;
  placeholder: string;
  helperText: string;
  spaceMultiplier: number;
  requiredError: string;
  attendee: string;
  attendees: string;
  message: string;
  mobileRequiredError: string;
};

export type GuestRoomsAndEventSpace = {
  label: string;
  ariaLabel: string;
  placeHolderText: string;
  requiredError: string;
  message: string;
};

export type Ctas = {
  find: string;
  findAriaLabel: string;
  reset: string;
  resetAriaLabel: string;
  update: string;
  updateAriaLabel: string;
  apply: string;
  applyAriaLabel: string;
};

export type SearchCriteria = {
  destination?: string;
  placeId?: string;
  startDate?: string;
  endDate?: string;
  guestRooms?: string;
  attendees?: string;
};

export enum TabType {
  ROOMS = 'ROOMS',
  EVENTSPACE = 'EVENTSPACE',
  ROOMSANDEVENTSPACE = 'ROOMSANDEVENTSPACE',
}
